import { CommonModule } from '@angular/common';
import { AfterViewInit, Component, ElementRef, Input, OnDestroy } from '@angular/core';

@Component({
  selector: 'wct-grid-layout',
  standalone: true,
  imports: [CommonModule],
  template: '<ng-content/>',
  styleUrls: ['./grid-layout.component.scss'],
})
export class GridLayoutComponent implements AfterViewInit, OnDestroy {
  @Input({ required: false }) public set columns(value: number | 'auto') {
    if (value === this._columns) {
      return;
    }

    this._columns = value;

    if (this.viewInitialized) {
      this.updateColumns(value);
    }
  }

  private readonly mutationObserver: MutationObserver;
  private _columns: number | 'auto';
  private viewInitialized: boolean = false;

  constructor(private readonly element: ElementRef<HTMLElement>) {
    this.mutationObserver = new MutationObserver(this.handleMutation);
  }

  public ngAfterViewInit(): void {
    this.updateColumns(this._columns ?? 'auto');
    this.viewInitialized = true;
  }

  public ngOnDestroy(): void {
    this.mutationObserver.disconnect();
  }

  private conntectMutationObserver(): void {
    this.mutationObserver.observe(this.element.nativeElement, { childList: true });
  }

  private readonly handleMutation: MutationCallback = mutationList => {
    for (const mutation of mutationList) {
      if (mutation.type !== 'childList') {
        continue;
      }

      this.updateGridStyle('auto');

      return;
    }
  };

  private updateColumns(columns: number | 'auto'): void {
    if (columns === 'auto') {
      this.conntectMutationObserver();
      this.updateGridStyle('auto');
    } else {
      this.mutationObserver.disconnect();
      this.updateGridStyle(columns);
    }
  }

  private updateGridStyle(columns: number | 'auto'): void {
    const count: number = columns !== 'auto' ? columns : this.element.nativeElement.childElementCount;
    this.element.nativeElement.style.gridTemplateColumns = `repeat(${count}, 1fr)`;
  }
}

